<template>
  <Card
    :class="$style.card"
  >
    <Grid
      :class="$style.cardGrid"
    >
      <GridItem
        :class="$style.cardBody"
        :gridSpan="12"
      >
        <HeadingLarge>
          Cost Calculator
        </HeadingLarge>
        <ParagraphBody>
          Answer a few questions about your environment. Get a plan recommendation and a rough
          pricing estimate based on your number of users.
        </ParagraphBody>
        <div :class="$style.buttonContainer">
          <Button
            text="get started"
            type="primary"
            @click="handleGetStartedClicked"
          />
        </div>
      </GridItem>
      <GridItem
        :gridSpan="5"
      >
        <img src="img/icons/life-size-calculator.svg">
      </GridItem>
    </Grid>
  </Card>
</template>

<script>
import {
  Button,
  Card,
  Grid,
  GridItem,
  HeadingLarge,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { eventLocations, eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import ModalEventBus from 'components/Modal/ModalEventBus';
import PricingCalculatorModal from 'client/Pricing/PricingCalculator/PricingCalculatorModal.vue';

const {
  description,
  location,
  text,
  section,
} = eventProperties;

const {
  pricingPage,
} = eventLocations;

export default {
  name: 'PricingCalculatorCard',

  EventHelper,
  ModalEventBus,

  components: {
    Button,
    Card,
    Grid,
    GridItem,
    HeadingLarge,
    ParagraphBody,
  },

  methods: {
    handleGetStartedClicked() {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'get started button clicked',
        [location]: pricingPage,
        [section]: 'pricing calculator card',
        [text]: 'get started',
      });
      this.openPricingCalculator();
    },

    openPricingCalculator() {
      this.$options.ModalEventBus.open({
        component: PricingCalculatorModal,
        isLargeModal: true,
      });
    },
  },
};
</script>

<style module scoped>
@import './css/customerSupportCard.css';
</style>
